<template>
  <div>
  <div class="left_content" v-show="!coverHidden">
    <div
      class="back-btn"
      @click="handleBackBtnClick"
      v-if="(!$root.$data.isApp&&!this.$root.miniprogram) || playIcon"
    >
      <img src="../../../assets/img/public/back.png" alt="返回" />
    </div>
    <!-- 主图 -->
    <div class="left_main_img">
      <swiper class="main_img_box" ref="mySwiper1" id="mySwiper1" @slideChange="slideChange">
        <swiper-slide :id="{ id: index }" v-for="(item, index) in coverList" :key="index">
          <img class="main_img" :src="item" />
        </swiper-slide>
      </swiper>
      <div
        class="swiper_num"
        v-if="coverList.length !== 0  && coverList.length !== 1 && (!buyStatus.length && showLiveInfo)"
      >{{coverIndex + 1}}/{{coverList.length}}</div>
      <div
        class="swiper_num swiper_num_bottom"
        v-if="coverList.length !== 0  && coverList.length !== 1 && !(!buyStatus.length && showLiveInfo)"
      >{{coverIndex + 1}}/{{coverList.length}}</div>
      <!-- <img class="main_img" :src="courseBaseData.coverMobile" alt /> -->
      <!-- 试听按钮 -->
      <div class="course_audition" @click="toAudition" v-if="isShowAudition && !flagHeader">
        <!--      <div class="course_audition" @click="toAudition" v-if="true">-->
        <img
          class="icon_audition"
          src="../../../assets/img/components/courseDetail/icon_audition_big.png"
          alt
        />
        <p class="audition_txt">支持试听</p>
      </div>
      <!-- 视频按钮 -->
      <div class="course_audition" @click="toAuditionVideo" v-if="flagHeader">
        <!--      <div class="course_audition" @click="toAudition" v-if="true">-->
        <img
          class="icon_audition"
          src="../../../assets/img/components/courseDetail/icon_audition_big.png"
          alt
        />
      </div>
      <!-- 直播信息   -->
      <div class="live_course_enrty" v-if="!buyStatus.length && showLiveInfo">
        <!--  未开始  -->
        <div class="not_start" v-if="showLiveInfo === 1">
          <span v-if="cutdownTime.type === 1">【即将开播】时间：{{ cutdownTime.times }}</span>
          <span v-else>【直播马上开始】倒计时：{{ cutdownTime.times }}</span>
        </div>
        <!-- 直播中 单个直播 -->
        <div
          class="start"
          @click="openLiveListBox"
          v-if="showLiveInfo === 2 && liveVideoBanner.length === 1"
        >
          <div>
            <img src="../../../assets/img/components/courseDetail/icon_liveing.png" alt />
            <p class="ellipsis">
              <i
                v-if="liveVideoBanner[0].name.substr(0, 1) == '【'"
                class="title-special-processing"
              />
              {{ liveVideoBanner[0].name }}
            </p>
          </div>
          <div>
            <span>领取并进入课堂</span>
            <img src="../../../assets/img/components/courseDetail/arrow_right.png" alt />
          </div>
        </div>
        <!-- 直播中 多个直播 -->
        <swiper
          :options="swiperOption"
          ref="mySwiper"
          v-if="showLiveInfo === 2 && liveVideoBanner.length > 1"
          @click.native="openLiveListBox"
        >
          <swiper-slide class="start" v-for="(item, index) in liveVideoBanner" :key="index">
            <div>
              <img src="../../../assets/img/components/courseDetail/icon_liveing.png" alt />
              <p class="ellipsis">
                <i v-if="item.name.substr(0, 1) == '【'" class="title-special-processing" />
                {{
                item.name
                }}
              </p>
            </div>
            <div>
              <span>领取并进入课堂</span>
              <img src="../../../assets/img/components/courseDetail/arrow_right.png" alt />
            </div>
          </swiper-slide>
        </swiper>
      </div>
    </div>
    <!-- 多个直播列表弹窗 -->
    <!--    <CoursePopup ref="popup" @triggerOpenRoom="receiveOpenRoom" :orderInfo="{}" />-->
    <dialogComponent ref="dialogComponent" dialogType="downloadApp" />
  </div>
    <contention-dialog
      :dialogShow="showContentionDialog"
      :onClose="confirmBack"
      :onStay="openChat"
      @close="dialogClose"
    />
  </div>
</template>
<script>
import { mapState } from 'vuex';
// eslint-disable-next-line import/no-extraneous-dependencies
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import ContentionDialog from '@/components/RetentionDialog/index.vue';
import dialogComponent from '@/components/dialogComponent/dialogComponent.vue';
import { timerCount, dateTime, replaceHyphens } from '../../../utils/tools';
import { reqCurrentTime } from '../../../api/courseDetail';
// import CoursePopup from '../coursePopup';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'swiper/dist/css/swiper.css';

export default {
  components: {
    // CoursePopup,
    swiper,
    swiperSlide,
    dialogComponent,
    ContentionDialog,
  },
  data() {
    return {
      salePrice: '', // 售价
      cutdownTime: {
        times: {}, // 直播时间展示
        type: 0, // 0小于3天   1大于3天
      },
      showLiveInfo: 0, // 是否展示直播
      timers: null, // 定时器
      liveVideoBanner: [],
      coverList: [],
      coverIndex: 0,
      // swiper 配置
      swiperOption: {
        loop: true,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false,
        },
        direction: 'vertical',
        slidesPerView: 'auto',
      },
      currentTime: 0, // 服务器时间
      showContentionDialog: false,
    };
  },
  props: ['containCurriculumId', 'courseId', 'playIcon', 'flagHeader', 'coverHidden'],
  computed: {
    ...mapState(['courseBaseData', 'buyStatus', 'productSku', 'containCurriculumData']),
    // 是否展示试听
    isShowAudition() {
      return (
        !this.buyStatus.length &&
        this.containCurriculumData.videoInfoRespVOS &&
        this.containCurriculumData.videoInfoRespVOS.length
      );
    },
  },
  watch: {
    liveVideoBanner() {},
    containCurriculumData(data) {
      if (!data.livingInfoRespVOS && !data.futureLiveBroadcastInfoRespVO) {
        // 无直播
        this.showLiveInfo = 0;
      } else if (data.livingInfoRespVOS && data.livingInfoRespVOS.length) {
        // 直播中
        this.showLiveInfo = 2;
        this.liveVideoBanner = data.livingInfoRespVOS;
        if (
          data.futureLiveBroadcastInfoRespVO &&
          new Date(replaceHyphens(data.futureLiveBroadcastInfoRespVO.startTime)).getTime() <
            new Date().getTime()
        ) {
          this.liveVideoBanner.push(data.futureLiveBroadcastInfoRespVO);
        }
      } else if (data.futureLiveBroadcastInfoRespVO) {
        // 未开始
        this.showLiveInfo = 1;
        this.checkTime();
      }
    },
    courseBaseData(data) {
      // 默认取产品的价格
      this.salePrice = data.sellPrice;
    },
    productSku(data) {
      // 展示sku的价格
      this.salePrice = data.productSkuId ? data.price : this.courseBaseData.sellPrice;
    },
  },
  created() {},
  mounted() {
    // app 点击返回时触发
    window.beforePageLeave = this.beforePageLeave;
    this.coverList = this.courseBaseData.coverMobileList || [];
  },
  destroyed() {
    clearInterval(this.timers);
    if (window.beforePageLeave === this.beforePageLeave) {
      window.beforePageLeave = null;
    }
  },
  methods: {
    toAuditionVideo() {
      this.$emit('triggerVideo');
    },
    slideChange() {
      console.log('slideChange', this.$refs.mySwiper1.swiper.activeIndex);
      this.coverIndex = this.$refs.mySwiper1.swiper.activeIndex;
    },
    // 头部返回按钮
    handleBackBtnClick() {
      window.localStorage.removeItem('miniBeforePageName')
      if (this.salePrice >= 500) {
        this.showContentionDialog = true;
        this.confirmBack = this.goBack;
      } else {
        this.goBack();
      }
    },

    goBack() {
      // form22
      if (sessionStorage.getItem('back')) {
        sessionStorage.removeItem('back');
        this.$router.go(-1);
        return;
      }
      if (sessionStorage.getItem('from22')) {
        window.location.href = window.location.origin;
        return;
      }
      // 更多直播公开课
      if (sessionStorage.getItem('liveCourse')) {
        sessionStorage.removeItem('liveCourse');
        this.$router.go(-1);
        return;
      }
      this.$router.push({ name: 'home' });
    },
    // 跳转 试听（原生交互）
    toAudition() {
      if (this.$root.$data.isApp) {
        this.$sendToApp(
          'goTrialCoursePage',
          {
            courseId: this.courseId,
            productCurriculumId: this.containCurriculumId,
            courseName: this.courseBaseData.name,
          },
          false,
        );
      } else {
        this.$router.push({
          path: '/audition',
          query: {
            coursesId: this.courseId,
            containCurriculumId: this.containCurriculumId,
          },
        });
        // this.$refs.dialogComponent.show = true;
      }
    },
    // 服务器时间
    async getServerTime() {
      const current = await reqCurrentTime();
      this.currentTime = current.data
        ? new Date(replaceHyphens(current.data)).getTime()
        : new Date().getTime();
      return this.currentTime;
    },
    // 打开直播列表
    openLiveListBox() {
      if (this.liveVideoBanner.length > 1 && !this.salePrice) {
        // 免费课
        if (this.liveVideoBanner.length === 1) {
          // 无轮播
          this.$parent.receiveLiveRoom(0);
        } else {
          // 有轮播
          this.$emit('openLiveListBox');
        }
      } else {
        // 付费课 直接到确认订单页
        this.$parent.receiveLiveRoom(0);
      }
    },
    // 校验直播开始时间是否大于3天 区分展示时间ui
    async checkTime() {
      this.clearInter();
      this.liveVideoBanner = [];
      const now = await this.getServerTime();
      // const now = this.courseBaseData.currentTime;
      const startTime = new Date(
        replaceHyphens(this.containCurriculumData.futureLiveBroadcastInfoRespVO.startTime),
      ).getTime();
      let temp = startTime - now;
      if (temp < 0) {
        // 时间到了，但直播未开,将未开播的数据替换给直播中
        this.updateLiveBanner();
      } else if (temp / (1000 * 60 * 60 * 24) > 3) {
        this.cutdownTime.type = 1;
        this.cutdownTime.times = `${dateTime(startTime).year}年${dateTime(startTime).month}月${
          dateTime(startTime).day
        }日${dateTime(startTime).h}:${dateTime(startTime).m}`;
      } else {
        this.cutdownTime.type = 0;
        this.getInterval(temp);
        this.timers = setInterval(() => {
          temp -= 1000;
          if (temp > 0) {
            this.getInterval(temp);
          } else {
            this.clearInter();
            // 时间到了,将未开播的数据替换给直播中
            this.updateLiveBanner();
          }
        }, 1000);
      }
    },
    updateLiveBanner() {
      this.liveVideoBanner.push(this.containCurriculumData.futureLiveBroadcastInfoRespVO);
      this.showLiveInfo = 2;
    },
    getInterval(temp) {
      if (temp > 0) {
        const countTime = timerCount(temp, 2);
        this.cutdownTime.times = `${countTime.d !== '00' ? `${countTime.d}天` : ''}${countTime.h}:${
          countTime.m
        }:${countTime.s}`;
        // console.log(this.cutdownTime.times);
      } else {
        // 倒计时结束
        this.clearInter();
      }
    },
    clearInter() {
      // console.log('-----直播倒计时结束----');
      clearInterval(this.timers);
    },
    receiveOpenRoom(itemLive) {
      this.$emit('triggerLiveRoom', itemLive);
    },
    dialogClose() {
      this.showContentionDialog = false;
    },

    openChat() {
      mantis.requestChat();
    },

    beforePageLeave() {
      if (this.salePrice >= 500) {
        this.showContentionDialog = true;
        this.confirmBack = () => {
          this.$sendToApp('closePage');
        };
      } else {
        this.$sendToApp('closePage');
      }
    },

    confirmBack() {},
  },
};
</script>
<style scoped lang="scss">
//主图
.left_content {
  position: relative;
  width: 100%;
  height: auto;

  .back-btn {
    position: absolute;
    top: 30px;
    left: 30px;
    z-index: 999;
    width: 64px;
    height: 64px;
    cursor: pointer;

    img {
      width: 64px;
      height: 64px;
    }
  }

  .left_main_img {
    position: relative;
    width: 100%;
    min-height: 543px;
    .main_img_box {
      z-index: 0;
      min-height: 543px !important;
    }
    .swiper_num {
      position: absolute;
      top: 426px;
      right: 36px;

      width: 65px;
      height: 36px;
      background: rgba(0, 0, 0, 0.7);
      border-radius: 18px;

      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 22px;
      color: #ffffff;
      line-height: 36px;
      text-align: center;
    }
    .swiper_num_bottom {
      top: 490px;
    }
    .main_img {
      display: block;
      width: 100%;
      min-height: 543px;
    }
    // 试听btn
    .course_audition {
      position: absolute;
      top: 50%;
      left: 50%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 127px;
      transform: translate(-50%, -50%);
      .icon_audition {
        display: block;
        width: 127px;
        height: auto;
        margin: 0 auto;
      }
      .audition_txt {
        width: 163px;
        height: 36px;
        margin-top: 30px;
        color: #fff;
        font-size: 22px;
        line-height: 36px;
        text-align: center;
        background: rgba(0, 0, 0, 0.5);
        border-radius: 18px;
      }
    }
    .live_course_enrty {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 63px;
      background: rgba(0, 0, 0, 0.5);
      .not_start {
        width: 100%;
        height: 63px;
        color: #fff;
        font-size: 25px;
        line-height: 63px;
        text-align: center;
      }
      .start {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 63px;
        padding: 0 20px;
        line-height: 63px;
        cursor: pointer;
        > div:nth-child(1) {
          display: flex;
          align-items: center;
          > img {
            width: 35px;
            height: auto;
            margin-left: 20px;
          }
          > p {
            width: 380px;
            margin-left: 16px;
            color: #fff;
            font-size: 25px;
            text-align: left;
          }
        }
        > div:nth-child(2) {
          display: flex;
          align-items: center;
          justify-content: space-between;
          color: #fff;
          font-size: 22px;
          span {
            color: #fff;
            font-size: 22px;
          }
          img {
            width: 42px;
            height: auto;
          }
        }
      }
    }
  }
}
::v-deep .swiper-container,
::v-deep .swiper-wrapper {
  // height: 63px;
}
</style>
